import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

type IDisclaimerModalProps = {
  open: boolean;
  openModal: (param: string | null) => void;
  closeModal: () => void;
  link: string | null;
};

export const useDisclaimerModal = (isDisclaimerEnable: boolean): IDisclaimerModalProps => {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState<string | null>('');
  const studySwitcherTrigger = useSelector(
    (state: RootState) => state.studySwitcher.studySwitcherTrigger
  );

  const openModal = (param: string | null) => {
    setOpen(true);
    setLink(param);
  };
  const closeModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (!isDisclaimerEnable) {
      return;
    }

    const handleAnchorClick = function (this: Element, e: Event) {
      const linkName = this.getAttribute('href');
      openModal(linkName);
      e.preventDefault();
    };

    let anchors: Element[] = [];

    const attachListeners = () => {
      anchors = Array.from(document.getElementsByClassName('open-disclaimer'));
      anchors.forEach((anchor) => {
        anchor.addEventListener('click', handleAnchorClick);
      });
    };

    // Defer so Study Switcher tab content is in the DOM before binding.
    const timeoutId = setTimeout(attachListeners, 0);

    return () => {
      clearTimeout(timeoutId);
      anchors.forEach((anchor) => {
        anchor.removeEventListener('click', handleAnchorClick);
      });
    };
  }, [isDisclaimerEnable, studySwitcherTrigger]);

  return { open, openModal, closeModal, link };
};

export default useDisclaimerModal;
